import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  chart,
  inferTypes,
  getOptionsConfig,
  getDefaultOptionsValues,
} from "@rawgraphs/rawgraphs-core";
import {
  barchart,
  piechart,
  linechart,
  boxplot,
} from "@rawgraphs/rawgraphs-charts";

import HandsOnTable from "./HandsOnTable";
import LoaderHolder from "./LoaderHolder";

import saveIcon from "../assets/save2.svg";
import exportIcon from "../assets/export2.svg";
import shareIcon from "../assets/share.svg";
import forwardIcon from "../assets/forward-arrow.svg";
import abcIcon from "../assets/abc.svg";
import numberIcon from "../assets/number.svg";

import { truncateText } from "../lib/utils";

import ColumnDropdown from "./ColumnDropdown";

const VisualizerArea = ({ chartData, chartType, loading, selectedFile }) => {
  // const [chartData, setChartData] = useState([
  //   {
  //     "Farm Name": "Green Acres",
  //     Category: "Vegetables",
  //     Item: "Tomatoes",
  //     "Farmer ID": 1001,
  //     Website: "www.greenacres.com",
  //     Suite: "A",
  //     Zipcode: 12345,
  //     Phone1: "555-0101",
  //     Business: "Family Owned",
  //     "Location 1": "123 Farm Rd, Ruralville",
  //     "Planning Regions": 1,
  //     Counties: 1,
  //     "Zip Code": 12345,
  //     "Town Index": 50,
  //   },
  //   {
  //     "Farm Name": "Sunny Fields",
  //     Category: "Fruits",
  //     Item: "Apples",
  //     "Farmer ID": 1002,
  //     Website: "www.sunnyfields.com",
  //     Suite: "B",
  //     Zipcode: 23456,
  //     Phone1: "555-0202",
  //     Business: "Cooperative",
  //     "Location 1": "456 Orchard Ln, Fruitville",
  //     "Planning Regions": 2,
  //     Counties: 2,
  //     "Zip Code": 23456,
  //     "Town Index": 75,
  //   },
  //   {
  //     "Farm Name": "Moo Meadows",
  //     Category: "Dairy",
  //     Item: "Milk",
  //     "Farmer ID": 1003,
  //     Website: "www.moomdows.com",
  //     Suite: "C",
  //     Zipcode: 34567,
  //     Phone1: "555-0303",
  //     Business: "Corporate",
  //     "Location 1": "789 Dairy Dr, Cowtown",
  //     "Planning Regions": 1,
  //     Counties: 3,
  //     "Zip Code": 34567,
  //     "Town Index": 100,
  //   },
  //   {
  //     "Farm Name": "Clucky's Coop",
  //     Category: "Poultry",
  //     Item: "Eggs",
  //     "Farmer ID": 1004,
  //     Website: "www.cluckyscoop.com",
  //     Suite: "D",
  //     Zipcode: 45678,
  //     Phone1: "555-0404",
  //     Business: "Family Owned",
  //     "Location 1": "101 Hen St, Eggville",
  //     "Planning Regions": 3,
  //     Counties: 1,
  //     "Zip Code": 45678,
  //     "Town Index": 25,
  //   },
  //   {
  //     "Farm Name": "Honey Haven",
  //     Category: "Specialty",
  //     Item: "Honey",
  //     "Farmer ID": 1005,
  //     Website: "www.honeyhaven.com",
  //     Suite: "E",
  //     Zipcode: 56789,
  //     Phone1: "555-0505",
  //     Business: "Cooperative",
  //     "Location 1": "202 Bee Blvd, Sweetville",
  //     "Planning Regions": 2,
  //     Counties: 2,
  //     "Zip Code": 56789,
  //     "Town Index": 60,
  //   },
  //   {
  //     "Farm Name": "Wooly Wonders",
  //     Category: "Livestock",
  //     Item: "Wool",
  //     "Farmer ID": 1006,
  //     Website: "www.woolywonders.com",
  //     Suite: "F",
  //     Zipcode: 67890,
  //     Phone1: "555-0606",
  //     Business: "Family Owned",
  //     "Location 1": "303 Sheep Ln, Wooltown",
  //     "Planning Regions": 1,
  //     Counties: 3,
  //     "Zip Code": 67890,
  //     "Town Index": 40,
  //   },
  //   {
  //     "Farm Name": "Grain Galore",
  //     Category: "Grains",
  //     Item: "Wheat",
  //     "Farmer ID": 1007,
  //     Website: "www.graingalore.com",
  //     Suite: "G",
  //     Zipcode: 78901,
  //     Phone1: "555-0707",
  //     Business: "Corporate",
  //     "Location 1": "404 Wheat Way, Grainville",
  //     "Planning Regions": 3,
  //     Counties: 1,
  //     "Zip Code": 78901,
  //     "Town Index": 90,
  //   },
  //   {
  //     "Farm Name": "Leafy Greens",
  //     Category: "Vegetables",
  //     Item: "Lettuce",
  //     "Farmer ID": 1008,
  //     Website: "www.leafygreens.com",
  //     Suite: "H",
  //     Zipcode: 89012,
  //     Phone1: "555-0808",
  //     Business: "Family Owned",
  //     "Location 1": "505 Salad St, Greenville",
  //     "Planning Regions": 2,
  //     Counties: 2,
  //     "Zip Code": 89012,
  //     "Town Index": 30,
  //   },
  //   {
  //     "Farm Name": "Berry Best",
  //     Category: "Fruits",
  //     Item: "Strawberries",
  //     "Farmer ID": 1009,
  //     Website: "www.berrybest.com",
  //     Suite: "I",
  //     Zipcode: 90123,
  //     Phone1: "555-0909",
  //     Business: "Cooperative",
  //     "Location 1": "606 Berry Blvd, Jamtown",
  //     "Planning Regions": 1,
  //     Counties: 3,
  //     "Zip Code": 90123,
  //     "Town Index": 80,
  //   },
  //   {
  //     "Farm Name": "Nutty Nook",
  //     Category: "Specialty",
  //     Item: "Almonds",
  //     "Farmer ID": 1010,
  //     Website: "www.nuttynook.com",
  //     Suite: "J",
  //     Zipcode: 1234,
  //     Phone1: "555-1010",
  //     Business: "Family Owned",
  //     "Location 1": "707 Nut Ave, Crunchville",
  //     "Planning Regions": 3,
  //     Counties: 1,
  //     "Zip Code": 1234,
  //     "Town Index": 55,
  //   },
  // ]);
  const [mapping, setMapping] = useState({});
  const [dataTypes, setDataTypes] = useState({});
  const [dataColumns, setDataColumns] = useState([]);
  const [chartConfig, setChartConfig] = useState(null);
  const [error, setError] = useState(null);
  const [shouldRenderChart, setShouldRenderChart] = useState(false);
  const visualizationRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);

  const [visualOptions, setVisualOptions] = useState(() => {
    const options = getOptionsConfig(chartConfig?.visualOptions);
    return getDefaultOptionsValues(options);
  });

  const assignChartByType = useCallback((chartType) => {
    switch (chartType) {
      case "barchart":
        return barchart;
      case "piechart":
        return piechart;
      case "linechart":
        return linechart;
      case "boxplot":
        return boxplot;
      default:
        return null;
    }
  }, []);

  useEffect(() => {
    if (chartData && chartData.length > 0) {
      //infer datatype
      const detectedTypes = inferTypes(chartData);

      setDataTypes(detectedTypes);

      const dataColumns = Object.keys(chartData[0]).map((key) => {
        return {
          columnName: key,
          type: detectedTypes[key],
        };
      });

      setDataColumns(dataColumns);
    }
  }, [chartData]);

  useEffect(() => {
    const newChartConfig = assignChartByType(chartType);
    if (newChartConfig) {
      setChartConfig(newChartConfig);
      const options = getOptionsConfig(newChartConfig?.visualOptions);
      setVisualOptions(getDefaultOptionsValues(options));
      const newMappings = {};
      newChartConfig.dimensions.forEach((dim) => {
        newMappings[dim.id] = "";
      });
      setMapping(newMappings);
      setShouldRenderChart(true);
    } else {
      setChartConfig(null);
      setMapping({});
      setShouldRenderChart(false);
    }

    if (visualizationRef.current) {
      visualizationRef.current.innerHTML = "";
    }
  }, [chartType, assignChartByType]);

  const handleMappingChange = (dimensionId, value) => {
    setMapping((prevMapping) => {
      const dimension = chartConfig.dimensions.find(
        (dim) => dim.id === dimensionId,
      );

      let newValues;
      if (dimension.multiple) {
        const currentValues = prevMapping[dimensionId]?.value || [];
        newValues = currentValues.includes(value)
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value];
      } else {
        newValues = [value];
      }

      // Determine the correct aggregation based on the dimension and data type
      const aggregation = newValues.map(() => {
        if (dimension.aggregation) {
          const dataType = dataTypes[value];
          if (typeof dimension.aggregationDefault === "object") {
            return dimension.aggregationDefault[dataType] || undefined;
          } else if (typeof dimension.aggregationDefault === "string") {
            return dimension.aggregationDefault;
          }
        }
        return null;
      });

      return {
        ...prevMapping,
        [dimensionId]: {
          value: newValues,
          config: {
            aggregation,
          },
        },
      };
    });
    setError(null);
    setShouldRenderChart(true);
  };

  const renderVisualization = useCallback(() => {
    if (!chartConfig || !chartData?.length || !shouldRenderChart) return;

    const formattedMapping = Object.keys(mapping).reduce((acc, key) => {
      const dimension = chartConfig.dimensions.find((dim) => dim.id === key);
      const mappingValue = mapping[key] || {};
      const values = mappingValue.value || [];

      acc[key] = {
        ids: dimension?.ids || [],
        value: values,
        isValid: true,
        mappedType: dataTypes[values[0]] || "string",
        config: mappingValue.config || {},
      };

      return acc;
    }, {});

    const allRequiredMappings = chartConfig.dimensions
      .filter((dimension) => dimension.required)
      .every((dimension) => mapping[dimension.id]?.value?.length > 0);

    if (!allRequiredMappings) return;

    try {
      if (visualizationRef.current) {
        visualizationRef.current.innerHTML = "";
      }
      const viz = chart(chartConfig, {
        data: chartData,
        mapping: formattedMapping,
        dataTypes,
        visualOptions: {
          ...visualOptions,
          width: 600,
          height: 550,
          showLegend: true,
        },
      });
      console.log({ viz });
      viz.renderToDOM(visualizationRef.current);
      setChartInstance(viz);
      //  setChartState(viz.getChartState());
      setError(null);
    } catch (err) {
      setError(`Error rendering visualization: ${err.message}`);
    }
  }, [
    chartConfig,
    chartData,
    dataTypes,
    mapping,
    shouldRenderChart,
    visualOptions,
  ]);

  useEffect(() => {
    if (shouldRenderChart && chartType !== "table") {
      renderVisualization();
    } else if (visualizationRef.current) {
      visualizationRef.current.innerHTML = "";
    }
  }, [renderVisualization, shouldRenderChart, chartType]);

  const handleExport = useCallback(() => {
    if (!chartInstance || !visualizationRef.current) return;

    const svgElement = visualizationRef.current.querySelector("svg");
    if (!svgElement) {
      setError("No SVG element found to export");
      return;
    }

    // Export as SVG
    const svgString = new XMLSerializer().serializeToString(svgElement);
    const blob = new Blob([svgString], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${chartType}_export.svg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, [chartInstance, chartType]);

  return (
    <div className="bg-light-purple h-full col-span-11">
      <header className="shadow-sm flex gap-x-10 bg-light-purple border-b border-faint-border py-4 px-10">
        <button className="flex items-center gap-x-2">
          <img src={saveIcon} alt="save icon" />
          <span className="text-sm">Save</span>
        </button>
        <button onClick={handleExport} className="flex items-center gap-x-2">
          <img src={exportIcon} alt="export icon" />
          <span className="text-sm">Export</span>
        </button>
        <button className="flex items-center gap-x-2">
          <img src={shareIcon} alt="share icon" />
          <span className="text-sm">Share</span>
        </button>
      </header>

      <div
        style={{ height: "calc(100vh - 120px)" }}
        className="grid grid-cols-12"
      >
        <section className="col-span-9 py-10 px-8">
          {chartType === "table" ? (
            <div className="bg-white h-full">
              {loading ? (
                <LoaderHolder message="Setting up data table, please be patient" />
              ) : (
                selectedFile?.table_data && (
                  <HandsOnTable
                    pagination
                    highlightOnHover
                    fixedHeader
                    striped
                    columns={selectedFile?.parsedFile?.columns}
                    data={selectedFile.table_data}
                  />
                )
              )}
            </div>
          ) : (
            <div className="bg-white h-full">
              {error && <div className="text-red-500 mb-4">{error}</div>}
              {loading ? (
                <LoaderHolder message="Setting up data, please be patient" />
              ) : (
                <div className="py-4 px-2" ref={visualizationRef} />
              )}
            </div>
          )}
        </section>

        <section className="col-span-3 bg-white">
          <div className="py-4 px-3 flex items-center gap-x-2 border-b border-faint-border">
            <h3 className="text-sm text-purple-3">Configuration</h3>

            {chartType && (
              <div className="flex items-center gap-x-2">
                <img src={forwardIcon} alt="chart name" />
                <div className="capitalize text-xs">{chartType}</div>
              </div>
            )}
          </div>

          <div
            style={{
              height: "calc(100vh - 174px)",
            }}
            className="grid grid-cols-2 overflow-hidden"
          >
            <div className="py-3 px-2">
              <h4 className="text-xs text-purple-3">Chart Descriptors</h4>
              <form>
                <div className="mb-1">
                  <label className="text-small">Title</label>
                  <input
                    className="mt-3 w-full text-small border-b border-faint-border  focus:outline-none"
                    type="text"
                    placeholder="Title here"
                  />
                </div>

                <div>
                  <label className="text-small">Description</label>
                  <input
                    className="mt-3 w-full text-small border-b border-faint-border  focus:outline-none"
                    type="text"
                    placeholder="Description here"
                  />
                </div>
              </form>

              <div className="mt-5">
                <h4 className="text-xs text-purple-3 mb-2">Chart Settings</h4>
                {chartConfig &&
                  chartConfig.dimensions.map((dimension) => (
                    <div key={dimension.id} className="mb-3 relative">
                      <label
                        style={{
                          fontSize: "8px",
                        }}
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        {dimension.name}
                      </label>
                      {dimension.multiple ? (
                        <ColumnDropdown
                          options={dataColumns
                            .filter((column) =>
                              dimension.validTypes.includes(column.type),
                            )
                            .map((column) => ({
                              label: column.columnName,
                              value: column.columnName,
                            }))}
                          selectedValues={mapping[dimension.id]?.value || []}
                          onChange={(value) =>
                            handleMappingChange(dimension.id, value)
                          }
                          placeholder={dimension.name}
                        />
                      ) : (
                        <select
                          style={{
                            fontSize: "10px",
                          }}
                          value={mapping[dimension.id]?.value?.[0] || ""}
                          onChange={(e) =>
                            handleMappingChange(dimension.id, e.target.value)
                          }
                          className="w-full py-2 border-b border-gray-300"
                        >
                          <option value="">{dimension.name}</option>
                          {dataColumns
                            .filter((column) =>
                              dimension.validTypes.includes(column.type),
                            )
                            .map((column, index) => (
                              <option key={index} value={column.columnName}>
                                {column.columnName}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                  ))}
              </div>
            </div>

            <div className="border-l border-faint-border py-3 px-2 overflow-y-auto">
              <h4 className="mb-4 text-xs">Available Columns</h4>
              <div className="flex flex-col gap-y-2">
                {dataColumns.map((item, index) => (
                  <div key={index} className=" flex items-center gap-x-3">
                    <img
                      src={item?.type === "number" ? numberIcon : abcIcon}
                      alt={item.type}
                    />
                    <span className="text-xs capitalize ">
                      {truncateText(item?.columnName, 15)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default VisualizerArea;
